export default __webpack_public_path__ + "static/media/register.cb596e79.jpeg";